import { teamQuery } from "@common/api/teams"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { TeamDetailsForm } from "@/routes/_layout/settings/_panel/workspace/teams/-components/form/team-details-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/teams/_list/$teamId",
)({
  loader: ({ context: { queryClient }, params: { teamId } }) =>
    queryClient.ensureQueryData(teamQuery(teamId)),
  staticData: { detailSidebar: true },
  component: TeamPanel,
})

function TeamPanel(): React.ReactElement {
  const { teamId } = Route.useParams()
  const { data: team } = useSuspenseQuery(teamQuery(teamId))
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const close = () =>
    navigate({ to: "/settings/workspace/teams", search: true })

  return (
    <TeamDetailsForm
      key={`${team.id}-${team.deleted_at}`}
      team={team}
      onClose={close}
      onRestore={() => showToast("Restored", "Record restored.", "success")}
      onSave={(saved) =>
        showToast("Saved", `${saved.name} updated.`, "success")
      }
    >
      <Outlet />
    </TeamDetailsForm>
  )
}
